// extracted by mini-css-extract-plugin
module.exports = {"description":"UpdateInvoiceInformation_description__3bRkw","header":"UpdateInvoiceInformation_header__1HfxS"};